import { Divider } from "@mui/material";

import type { FieldComponent } from "../types";

const DividerComponent: FieldComponent<never> = ({ field }) => (
  <Divider
    sx={{
      my: 3,
      borderColor: "grey.400",
      borderBottomWidth: 2,
      width: "100%",
      ...field.sx,
    }}
    className={field.className}
    style={field.style}
  />
);

export default DividerComponent;
